"use strict";
document.querySelector("#thumbs").onclick = function(eve) {
    var link = eve.target.closest("a");
    if (!link) return;
    var largImg = document.querySelector("#largeImg");
    largImg.src = link.href;
    return false;
};

//# sourceMappingURL=index.d0ee56a4.js.map
